import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var brandCategorySchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете slug',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    hidden: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'скрита категория',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    parent_id: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'autocomplete',
        label: 'Бащина категория',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна бащина категория',
    }),
    meta_title: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'input',
        label: 'Meta Заглавие',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно заглавие',
    }),
    meta_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Meta Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно описание',
    }),
};
export default brandCategorySchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/brandCategorySchema.ts
// module id = 533
// module chunks = 0